import React, { useState } from "react";
import {
  Button,
  Popover,
  Typography,
  Box,
  IconButton,
  Tooltip,
  Stack,
  Paper,
  colors,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Autocomplete,
  TextField,
} from "@mui/material";
import {
  FilterButtonIcon,
  ActiveFilterButtonIcon,
} from "../Icons/DataTableIcons";
import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import StateAutoComplete from "../TextFields/StateSelect";
import SectorAutoComplete from "../TextFields/SectorSelect";
import ZoneAutoComplete from "../TextFields/ZoneSelect";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
  boxShadow: "none",
}));

const FilterButton = ({ options, onClick, reset, filters }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = React.useState({});
  const [autoCompleteValue, setAutoCompleteValue] = React.useState({});
  const [autoCompleteZoneValue, setAutoCompleteZoneValue] = React.useState({});
  const handleClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setAnchorEl(null);
  };

  const handleRadioGroup = (event, name) => {
    setValue({
      ...value,
      [name]: event.target.value,
    });
  };

  const handleChange = (event, name) => {
    event.preventDefault();
    setValue({
      ...value,
      [name]: event.target.value,
    });
  };

  const handleAutoCompleteChange = (event, value, name) => {
    event.preventDefault();
    setAutoCompleteValue({
      value: value,
    });
    setValue((prevState) => ({
      ...prevState,
      states: value.value,
    }));
  };
  const handleSectorAutoCompleteChange = (event, value, name) => {
    event.preventDefault();
    setAutoCompleteValue({
      value: value,
    });
    setValue((prevState) => ({
      ...prevState,
      sectors: value.value,
    }));
  };

  const handleZoneAutoCompleteChange = (event, value, name) => {
    debugger;
    event.preventDefault();
    setAutoCompleteZoneValue({
      value: value,
    });
    setValue((prevState) => ({
      ...prevState,
      [name]: value.value,
    }));
  };

  // const stateHandler = (event, val) => {
  //   if (event) {
  //     setStateValue(val.value);
  //     setFormValues((prevValues) => ({
  //       ...prevValues,
  //       businessFormValues: {
  //         ...prevValues.businessFormValues,
  //         stateId: val.value,
  //       },
  //     }));
  //     if (val.value !== 0) {
  //       setFormStates({
  //         ...formStates,
  //         stateOfResidenceError: false,
  //         stateOfResidenceErrorMsg: "",
  //       });
  //     }
  //   }
  // };
  const handleSubmit = (event) => {
    onClick(value);
  };

  const handleReset = (event) => {
    reset();
    setValue(0);
    setAutoCompleteValue(0);
  };
  return (
    <React.Fragment>
      <Tooltip title="Filter Table">
        <IconButton
          onClick={(e) => {
            handleClick(e);
          }}
        >
          {Object.keys(filters).length > 0 ? (
            <ActiveFilterButtonIcon />
          ) : (
            <FilterButtonIcon />
          )}
        </IconButton>
      </Tooltip>
      <Popover
        onClose={handleClose}
        sx={{ padding: "0px" }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box>
          <Stack spacing={0.3}>
            <Item sx={{ padding: "0px" }}>
              <Box sx={{ padding: "0px" }} display="flex" justifyContent="end">
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Item>
            <Box sx={{ padding: "0px 15px" }}>
              <Item>
                <Box
                  display="flex"
                  gap={5}
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ padding: "5px 0px" }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#202020",
                      marginBottom: "0px",
                    }}
                    variant="body1"
                    gutterBottom
                  >
                    Filters
                  </Typography>
                  <Box display="flex" gap={1}>
                    <Button
                      onClick={handleReset}
                      sx={{
                        borderRadius: "7px",
                        textTransform: "initial",
                        color: colors.grey[500],
                        borderColor: colors.grey[500],
                        "&:hover": { borderColor: colors.grey[500] },
                      }}
                      size="small"
                      variant="outlined"
                    >
                      Clear Filters
                    </Button>
                    <Button
                      disableElevation
                      onClick={handleSubmit}
                      sx={{
                        borderRadius: "7px",
                        textTransform: "initial",
                      }}
                      size="small"
                      variant="contained"
                    >
                      Apply Filters
                    </Button>
                  </Box>
                </Box>
              </Item>
              <Item>
                <Box sx={{ padding: "20px 0px", width: "300px" }}>
                  <Grid container spacing={3}>
                    {options.map((option, index) => (
                      <Grid
                        key={index}
                        item
                        xs={6}
                        sx={{ textAlign: "left", paddingLeft: "0px" }}
                      >
                        <div>
                          {option.type === "radio" ? (
                            <FormControl fullWidth size="small">
                              <FormLabel
                                sx={{ textAlign: "left" }}
                                id="demo-row-radio-buttons-group-label"
                              >
                                {option.group}
                              </FormLabel>
                              <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name={option.name}
                                value={value[option.name] || ""}
                                onChange={(e) => {
                                  handleRadioGroup(e, option.name);
                                }}
                              >
                                {option.options.map((item, index) => (
                                  <FormControlLabel
                                    sx={{
                                      "& svg": {
                                        width: "0.8em",
                                        height: "0.8em",
                                      },
                                    }}
                                    key={index}
                                    value={item.value}
                                    control={
                                      <Radio
                                        key={index}
                                        sx={{
                                          ontSize: "1px",
                                        }}
                                      />
                                    }
                                    label={item.label}
                                  />
                                ))}
                              </RadioGroup>
                            </FormControl>
                          ) : option.type === "dropdown" ? (
                            <FormControl
                              key={index}
                              fullWidth
                              variant="standard"
                              sx={{ m: 1, minWidth: 130 }}
                            >
                              <InputLabel id="demo-simple-select-standard-label">
                                {option.group}
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                name={option.name}
                                value={value[option.name] || 0}
                                onChange={(e) => handleChange(e, option.name)}
                                label={option.label}
                              >
                                {option.options.map((item, index) => (
                                  <MenuItem key={index} value={item.value}>
                                    {item.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          ) : option.type === "autocomplete" ? (
                            <StateAutoComplete
                              groupName={option.group}
                              names={option.name}
                              values={autoCompleteValue.value}
                              stateHandler={handleAutoCompleteChange}
                            />
                          ) : option.type === "sectorAutocomplete" ? (
                            <SectorAutoComplete
                              groupName={option.group}
                              names={option.name}
                              values={autoCompleteValue.value}
                              sectorHandler={handleSectorAutoCompleteChange}
                            />
                          ) : option.type === "zoneAutocomplete" ? (
                            <ZoneAutoComplete
                              groupName={option.group}
                              names={option.name}
                              values={autoCompleteZoneValue.value}
                              zoneHandler={handleZoneAutoCompleteChange}
                            />
                          ) : null}
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Item>
            </Box>
          </Stack>
        </Box>
      </Popover>
    </React.Fragment>
  );
};

export default FilterButton;
